import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main.component';
import { AuthGuard } from '../auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      //main page
      { path: '', redirectTo: '/', pathMatch: 'full' },
      {
        path: '',
        loadComponent: () =>
          import('./home-page/home-page.component').then(
            (mod) => mod.HomePageComponent
          ),
      },

      // blog page
      // {
      //   path: "blog",  canActivate: [AuthGuard,AuthGuard],
      //   loadComponent: () =>
      //     import('../shared/blog/blog.component').then((m) => m.BlogComponent),
      // },
      {
        path: 'blog',
        loadComponent: () =>
          import('../shared/blog/blog.component').then((m) => m.BlogComponent),
      },
      {
        path: 'blog/:slug',
        loadComponent: () =>
          import('../shared/blog/blog-detail/blog-detail.component').then(
            (m) => m.BlogDetailComponent
          ),
      },

      // Pricing page
      {
        path: 'pricing',
        loadComponent: () =>
          import('../shared/pricing/pricing.component').then(
            (m) => m.PricingComponent
          ),
      },

      // faq page
      {
        path: 'faq',
        loadComponent: () =>
          import('./../shared/faq/faq.component').then((m) => m.FaqComponent),
      },
      {
        path: 'faq-hall-page',
        loadComponent: () =>
          import('./../shared/faq-hall-page/faq-hall-page.component').then(
            (m) => m.FaqHallPageComponent
          ),
      },
      // about us page
      {
        path: 'about-us',
        loadComponent: () =>
          import('./../shared/about-us/about-us.component').then(
            (mod) => mod.AboutUsComponent
          ),
      },

      /// privacy policy
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./../shared/privacy-policy/privacy-policy.component').then(
            (mod) => mod.PrivacyPolicyComponent
          ),
      },

      //teams and conditions

      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import(
            './../shared/terms-and-conditions/terms-and-conditions.component'
          ).then((mod) => mod.TermsAndConditionsComponent),
      },
      // contact us page

      {
        path: 'contact-us',
        loadComponent: () =>
          import('../shared/contact-us/contact-us.component').then(
            (m) => m.ContactUsComponent
          ),
      },

      // Auth Module
      {
        path: 'login',
        loadComponent: () =>
          import('../auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('../auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'log-out',
        loadComponent: () =>
          import('../auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'select-profile',
        loadComponent: () =>
          import('../auth/select-profile/select-profile.component').then(
            (m) => m.SelectProfileComponent
          ),
      },

      //  Auth Select Vendor
      {
        path: 'select-service-provider',
        loadComponent: () =>
          import('../auth/select-vender/select-vender.component').then(
            (m) => m.SelectVenderComponent
          ),
      },
      // Auth Sign Up Vendor
      {
        path: 'sign-up-service-provider',
        loadComponent: () =>
          import(
            '../auth/vendor-signup-page/vendor-signup-page.component'
          ).then((m) => m.VendorSignupPageComponent),
      },
      // Auth Sign Up Hall Owner
      {
        path: 'sign-up-venue-provider',
        loadComponent: () =>
          import(
            '../auth/hall-owner-signup-page/hall-owner-signup-page.component'
          ).then((m) => m.HallOwnerSignupPageComponent),
      },

      //  hall listing page
      {
        path: 'wedding-venues',
        loadComponent: () =>
          import('../main/search-hall/search-hall.component').then(
            (mod) => mod.SearchHallComponent
          ),
      },
      {
        path: 'venues-and-marriage-halls',
        loadComponent: () =>
          import('../main/search-hall/search-hall.component').then(
            (mod) => mod.SearchHallComponent
          ),
      },
      {
        path: 'venues-and-marriage-halls/:place',
        loadComponent: () =>
          import('../main/search-hall/search-hall.component').then(
            (mod) => mod.SearchHallComponent
          ),
      },
      {
        path: 'catering-services',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (mod) => mod.VendorCompaniesComponent
          ),
      },
      {
        path: 'photography',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (mod) => mod.VendorCompaniesComponent
          ),
      },
      {
        path: 'makeup-artists',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (mod) => mod.VendorCompaniesComponent
          ),
      },
      {
        path: 'decor',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (mod) => mod.VendorCompaniesComponent
          ),
      },
      {
        path: 'musicians',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (mod) => mod.VendorCompaniesComponent
          ),
      },

      {
        path: 'mehndi-artists',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (mod) => mod.VendorCompaniesComponent
          ),
      },

      {
        path: 'vendor',
        loadComponent: () =>
          import('../main/search-venders/search-venders.component').then(
            (mod) => mod.SearchVendersComponent
          ),
      },

      {
        path: 'book-a-service/:slug',
        // path: ':slug/:type/:slug',
        loadComponent: () =>
          import('./booking/single-vendor/single-vendor.component').then(
            (mod) => mod.SingleVendorComponent
          ),
      },
      {
        path: 'user-profile',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'recent-orders',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'order-detail/:id',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'order-history',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'order-reservation',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'order-booked',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'wishlist',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'invoices',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'settings',
        canActivate: [AuthGuard, AuthGuard],
        loadComponent: () =>
          import('../shared/user-profile/user-profile.component').then(
            (mod) => mod.UserProfileComponent
          ),
      },

      {
        path: 'vendor-companies',
        loadComponent: () =>
          import('../vendor-companies/vendor-companies.component').then(
            (m) => m.VendorCompaniesComponent
          ),
      },
       //deals
       {
        path: 'deals',
        loadComponent: () =>
          import('./deals/deals-list/deals-list.component').then((m) => m.DealsListComponent),
      },
      {
        path: 'add-deal',
        loadComponent: () =>
          import('./deals/add-deal/add-deal.component').then((m) => m.AddDealComponent),
      },
      {
        path: 'deal/:slug',
        loadComponent: () =>
          import('./deals/deal-details/deal-details.component').then(
            (m) => m.DealDetailsComponent
          ),
      },
      //All  venue companies page
      {
        path: 'venue-companies',
        loadComponent: () =>
          import('../venue-companies/venue-companies.component').then(
            (m) => m.VenueCompaniesComponent
          ),
      },

      {
        path: ':slug',
        loadComponent: () =>
          import(
            './booking/venue-company-detail/venue-company-detail.component'
          ).then((mod) => mod.VenueCompanyDetailComponent),
      },
      {
        path: ':slug/:branchSlug',
        loadComponent: () =>
          import(
            './booking/venue-company-detail/venue-company-detail.component'
          ).then((mod) => mod.VenueCompanyDetailComponent),
      },
      {
        path: ':slug/:branch-slug/:hall-slug',
        loadComponent: () =>
          import('./booking/single-hall/single-hall.component').then(
            (mod) => mod.SingleHallComponent
          ),
      },

     
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
